import { render, staticRenderFns } from "./BibRecognitionPage.vue?vue&type=template&id=418d4e32&scoped=true&"
import script from "./BibRecognitionPage.vue?vue&type=script&lang=js&"
export * from "./BibRecognitionPage.vue?vue&type=script&lang=js&"
import style0 from "./BibRecognitionPage.vue?vue&type=style&index=0&id=418d4e32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418d4e32",
  null
  
)

export default component.exports